import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

@Component({
  selector: 'app-skills',
  standalone: true,
  imports: [ProgressBarComponent],
  templateUrl: './skills.component.html',
  styleUrl: './skills.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillsComponent {
  feSkills = [
    {
      title: 'Angular ',
      percent: 95,
    },
    {
      title: 'TypeScript',
      percent: 90,
    },
    {
      title: 'JavaScript (ES6+)',
      percent: 90,
    },
    {
      title: 'HTML & SCSS',
      percent: 95,
    },
    {
      title: 'RxJS',
      percent: 85,
    },
    {
      title: 'Responsive Design',
      percent: 90,
    },
    {
      title: 'Angular Material / Bootstrap CSS',
      percent: 80,
    },
    {
      title: 'State Management (NgRx Store, Services)',
      percent: 80,
    }
  ];

  beSkills = [
    {
      title: 'Node.js',
      percent: 85,
    },
    {
      title: 'Express.js',
      percent: 85,
    },
    {
      title: 'REST API Design',
      percent: 90,
    },
    {
      title: 'JWT Authentication',
      percent: 85,
    },
    {
      title: 'Socket.io (Real-time)',
      percent: 80,
    },
    {
      title: 'TypeORM',
      percent: 80,
    },
    {
      title: 'Sequelize',
      percent: 70,
    },
    {
      title: 'Backend Validation & Error Handling',
      percent: 80,
    }
  ];

  
  dbSkills = [
    {
      title: 'PostgreSQL',
      percent: 80,
    },
    {
      title: 'Redis',
      percent: 70,
    },
    {
      title: 'MongoDB (Basic)',
      percent: 60,
    },
    {
      title: 'Database Schema Design',
      percent: 80,
    },
    {
      title: 'ORM Usage (TypeORM / Sequelize)',
      percent: 80,
    },
    {
      title: 'Writing Optimized Queries',
      percent: 75,
    }
  ];

  otherSkills = [
    {
      title: 'Git / GitHub',
      percent: 90,
    },
    {
      title: 'AWS S3',
      percent: 70,
    },
    {
      title: 'Angular CLI',
      percent: 90,
    },
    {
      title: 'Unit Testing (Jest, Jasmine)',
      percent: 65,
    },
    {
      title: 'Agile / Scrum Workflow',
      percent: 85,
    }
  ];
  
  

  constructor() {
    // Object.assign(this, { single: this.single });
  }
}
